import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CustomerView } from './panes/customer-view';
import { FeatureFlagsView } from './panes/feature-flags-view';
import React from 'react';
import { Tabs } from 'antd';

export interface AdminDashboardTabsProps {
	id?: string;
}

const tabItems = [
	{
		children: <CustomerView />,
		key: '1',
		label: COPY_SPECIFIC.CUSTOMER_VIEW
	},
	{
		children: <FeatureFlagsView />,
		key: '2',
		label: COPY_SPECIFIC.FEATURE_FLAGS
	}
];

export const AdminDashboardTabs: React.FC<AdminDashboardTabsProps> = ({ id }) => <Tabs
	id={ id }
	items={ tabItems } />;
